"use client";

import { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import { Wrapper, Label } from "./option-group.styles";

export interface OptionGroupProps {
    /**
     * Caption of the option group.
     */
    label?: ReactNode | string;

    /**
     * Size of the option group.
     */
    size?: "sm" | "lg";

    /**
     * Class name of the button.
     */
    className?: string;
}

export const OptionGroup: FunctionComponent<PropsWithChildren<OptionGroupProps>> = ({ label, size, className, children }) => {
    return (
        <Wrapper className={className}>
            {label && <Label size={size}>{label}</Label>}
            {children}
        </Wrapper>
    );
};
